export const categories = [
    {
        name: "Character",
        namePlural: "Characters",
        image: "/images/explore/categories/Characters.svg",
        imageOnProfile: "/images/profile/icons/character.svg",
    },
    {
        name: "Companion",
        namePlural: "Companions",
        image: "/images/explore/categories/Companions.svg",
        imageOnProfile: "/images/profile/icons/companion.svg",
    },
    {
        name: "Mentor",
        namePlural: "Mentors",
        image: "/images/explore/categories/Mentors.svg",
        imageOnProfile: "/images/profile/icons/mentor.svg",
    },
    {
        name: "Assistant",
        namePlural: "Assistants",
        image: "/images/explore/categories/Assistants.svg",
        imageOnProfile: "/images/profile/icons/assistant.svg",
    },
]

export const subcategories = [
    ["Anime", "Movies", "TV Shows", "Games", "Kids Show", "Comic"],
    ["Boyfriend", "Girlfriend", "Friend", "Silly"],
    ["Religion", "Philosopher"],
    ["Helpers"],
]

export const languages = [
    {
        name: "English",
        flag: "/images/messages/flags/english.svg",
    },
    {
        name: "French",
        flag: "/images/messages/flags/french.svg",
    },
    {
        name: "German",
        flag: "/images/messages/flags/german.svg",
    },
    {
        name: "Hindi",
        flag: "/images/messages/flags/hindi.svg",
    },
    {
        name: "Italian",
        flag: "/images/messages/flags/italian.svg",
    },
    {
        name: "Polish",
        flag: "/images/messages/flags/polish.svg",
    },
    {
        name: "Portuguese",
        flag: "/images/messages/flags/portuguese.svg",
    },
    {
        name: "Spanish",
        flag: "/images/messages/flags/spanish.svg",
    },
]

export const monthNames = ["Janunary", "Feburary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]